export default __webpack_public_path__ + "static/nextjs-hero-06204509db40f1290c06a1696c1fd5de.png";